import React from 'react';
import Skeleton from 'react-loading-skeleton';
import { useSelector } from 'react-redux';
import CourseTopicListItem from './CourseTopicListItem';

export const CourseTopicList = ({ activeResource, activeChapterIndex, onChangeActiveResource }) => {
  const payload = useSelector((state) => state.course.detail.payload);

  return (
    <div className="overflow-hidden">
      <div className="space-y-5">
        {payload?.modules.map((chapter, index) => (
          <CourseTopicListItem
            key={chapter.uuid}
            title={chapter.title}
            resources={chapter.topics}
            activeResource={activeResource}
            onChangeActiveResource={onChangeActiveResource}
            open={activeChapterIndex ? activeChapterIndex === index : index === 0}
          />
        ))}
      </div>
    </div>
  );
};

CourseTopicList.Skeleton = () => {
  const renderAccordionItem = () => {
    return (
      <div className="flex flex-col py-2 space-y-1">
        <div className="flex items-center space-x-3">
          <Skeleton height={40} width={40} />
          <div className="w-full">
            <Skeleton height={25} />
            <Skeleton width={150} />
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="flex flex-col p-4 space-y-1 bg-white rounded-lg">
      <div>
        <div className="flex flex-col pb-2">
          <Skeleton height={40} />
        </div>
        <div>
          {renderAccordionItem()}
          {renderAccordionItem()}
          {renderAccordionItem()}
        </div>
        <div className="flex flex-col pt-2">
          <Skeleton height={40} />
        </div>
      </div>
    </div>
  );
};
